// extracted by mini-css-extract-plugin
export default {"loginModal":"loginModal-qo2IX","customModal":"customModal-acNdY"};